export default {
  header: 'Benefits of domain name privacy',
  purchasedNote: 'You’ve purchased this product',
  service: () => 'domain_name_privacy',
  allowMultiplePurchases: true,
  isAllowedToBuy: (_businessEntity, entitlements) => entitlements.has('domain_name_reg'),
  requirements: {
    product: {
      service: () => 'domain_name_reg',
      label: 'Purchase With a Domain'
    }
  },
  pricingText: ' - _PRICE_/YEAR',
  pricingInterval: 'annual',
  topButtonAnalytics: {
    pageSubSection: 'add-at-any-point',
    pagePosition: '3.3.2'
  },
  bottomButtonAnalytics: {
    pageSubSection: 'add-at-any-point',
    pagePosition: '3.3.2'
  },
  benefitsSection: [
    {
      image: '/s2/vector/domain-name-privacy.svg',
      subHeader: 'Privacy shield',
      description: 'Domain privacy shields all of your contact information (address, phone number, name, etc.) from being publicly available.'
    },
    {
      image: '/s2/vector/avoid-spams.svg',
      subHeader: 'Prevent spam & scams',
      description: 'Control spam or junk mail and prevent firms from capturing or scraping your information to scam you or sell it to others.'
    },
    {
      image: '/s2/vector/spam-emails.svg',
      subHeader: 'Limit solicitations',
      description: 'Block the potential barrage of companies that use your WHOIS information to solicit and sell you unwanted products and services.'
    }
  ],
  summary: {
    header: 'What is domain name privacy and why do I need it?',
    body: [
      'Every domain name owner must pass along their information to the ICANN (The Internet Corporation for Assigned Names and Numbers) WHOIS directory so they can maintain a record of every domain and who runs it.',
      'Your WHOIS listing makes your contact information (name, phone number, address, etc.) publicly available to anyone who looks for it online.',
      'Domain name privacy shields this contact information from the public and replaces it with the details of your domain registrar instead.',
      'For only $10 per year, ZenBusiness will provide WHOIS domain name privacy to protect your personal information, reduce spam and scams, and limit unwanted solicitations.'
    ]
  }
};
